module.exports = __webpack_public_path__ + "img/AL.bfd0a0ce.svg";